import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import { Image } from "@/components/ui/image";
import { VStack } from "@/components/ui/vstack";
import { Button } from "@/components/ui/button";
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'i18n-js';
import * as MediaSelector from '../components/media/MediaSelector';
import { backendLogin } from '../stores/thunks';
import { TouchableOpacity } from 'react-native-gesture-handler';
import FloatingLabelInput from "../components/basic/FloatingLabelInput";
import app from '../app.json'
import { switchScreen } from '../hooks/navigate';
import { GlobalState } from '../containers/GlobalState';
import QRCodeView from '../components/basic/QRCodeView';
import { demoLogin } from "../stores/mainSlice";
import { IconI } from "@/components/media/IconsV2";

const logos = [
  require('../assets/icons/icon_blue_rounded_512x512.png'),
  require('../assets/icons/icon_green_rounded_512x512.png'),
  require('../assets/icons/icon_yellow_rounded_512x512.png'),
  require('../assets/icons/icon_orange_rounded_512x512.png'),
  require('../assets/icons/icon_red_rounded_512x512.png'),
]

function Logo() {
  const inAColor = useSelector((state) => state.settings.inAColor == undefined ? 0 : state.settings.inAColor)
  return (
    <Image
      source={logos[inAColor]}
      alt={i18n.t('global.missingImage')}
      size='lg'
    />
  );
}

const InputFields = ({ navigation }) => {
  const [userid, setUserid] = useState('');
  const [password, setPassword] = useState('');
  const [hidden, setHidden] = useState(true);
  const dispatch = useDispatch()

  const login = () => {
    dispatch(backendLogin('LOGIN', { name: userid.trim(), passwd: password.trim() }))
  }

  const LoginButton = () => {
    return (
      <Button
        testID="login-button"
        onPress={() => {
          if (userid.trim().toUpperCase() == 'DEMO' && password.trim().toUpperCase() == 'DEMO') {
            dispatch(demoLogin())
          } else {
            login()
          }
        }}
        className="bg-primary-900 active:bg-primary-700">
        <Text className="text-lg text-secondary-50">{i18n.t('login.login')}</Text>
      </Button>
    );
  }

  const actionReset = () => {
    switchScreen(navigation, 'ModalResetPW', { mail: userid })
  }

  return (
    <VStack space='lg' className="w-[100%]">
      <FloatingLabelInput testID="login-email" size='lg' label={i18n.t('login.email')} textContentType='emailAddress' autoCapitalize='none' keyboardType='email-address' autoCorrect={false} autoCompleteType='email' placeholder={i18n.t('login.email')} onChangeText={(text) => setUserid(text)} />
      <FloatingLabelInput testID="login-password" size='lg' label={i18n.t('login.password')} type={hidden ? 'password' : ''} autoCapitalize='none' autoCorrect={false} placeholder={i18n.t('login.password')}
        onChangeText={(text) => setPassword(text)}
        onPress={() => { setHidden(!hidden) }} iconR={hidden ? 'visibility-off' : 'visibility'}
        onSubmitEditing={login}
      />
      <TouchableOpacity onPress={actionReset} className="bg-primary-900">
        <Text bold className="text-primary-900 text-md text-right">{i18n.t('login.resetPW')}</Text>
      </TouchableOpacity>
      <LoginButton />
    </VStack>
  );
}

const ScanButton = ({ navigation }) => {
  return (
    <Button onPress={() => switchScreen(navigation, 'QRCodeLogin')} className="bg-primary-900 active:bg-primary-700">
      <IconI className="text-xl text-secondary-50" name='qr-code-outline' />
      <Text className="text-lg px-2 text-secondary-50">{i18n.t('login.scan')}</Text>
    </Button>
  );
}

const Panel = (props) => {
  const ws = useSelector((state) => state.server.ws)
  const { isWeb } = useContext(GlobalState)

  const demoLogin = () => {
    switchScreen(props.navigation, 'ModalDemo')
  }

  return (
    <VStack space='lg' {...props} className="flex-1 bg-secondary-50 items-center justify-center">
      <Logo />
      <Text className="text-md text-primary-900">{'v' + app.expo.version}</Text>
      <VStack className="w-[90%]">
        <InputFields navigation={props.navigation} />
      </VStack>
      <VStack space='lg' className="w-[90%]">
        <Text className="text-black text-center">{i18n.t('login.or')}</Text>
        {isWeb ?
          <QRCodeView key={ws?.id} data={ws?.id} title={i18n.t('login.loginQRCode')} text={i18n.t('login.loginQRCodeText')} />
          : <ScanButton navigation={props.navigation} />}
      </VStack>
      {!isWeb && <TouchableOpacity onPress={demoLogin}>
        <Text bold className="text-primary-900 text-sm text-right mt-3">{i18n.t('login.demoMode')}</Text>
      </TouchableOpacity>}
    </VStack>
  );
}

export default function Login({ navigation }) {
  const { isWeb } = useContext(GlobalState)

  useEffect(() => {
    MediaSelector.requestPermissions()
    MediaSelector.ensureDirExists()
  }, [])

  return (isWeb ? <View className="flex-1 items-center">
    <Panel navigation={navigation} width={400} />
  </View> : <Panel navigation={navigation} />);
}
